import { FsRawNode } from '~/api/types';
import getInnerPath from './getInnerPath';

const findFolderByPath = (roots: FsRawNode[], path: string, isFullPath: boolean = true): FsRawNode | null => {
  const direct = roots.find((r) => r.path === path && r.is_dir);
  if (direct) return direct;

  const stack = [...roots];
  while (stack.length) {
    const node = stack.shift()!;
    if (!node.is_dir) continue;
    const innerPath = getInnerPath(node.path);

    const matchesPath = isFullPath ? node.path === path : innerPath === path;

    if (matchesPath) return node;

    for (const child of node.children ?? []) {
      if (child.is_dir) stack.push(child);
    }
  }

  return null;
};

export default findFolderByPath;
